/** Brzi lookup metrike po osobi i datumu (O(1) umjesto .find po cijelom nizu). */

export function buildMetricsByUserDate(metrics) {
  const map = new Map();
  (metrics || []).forEach((m) => {
    if (m.userId == null || m.year == null || m.month == null || m.day == null) return;
    map.set(`${m.userId}-${m.year}-${m.month}-${m.day}`, m);
  });
  return map;
}

export function groupMetricsByUserId(metrics) {
  const byUser = new Map();
  (metrics || []).forEach((m) => {
    if (!m.userId) return;
    if (!byUser.has(m.userId)) byUser.set(m.userId, []);
    byUser.get(m.userId).push(m);
  });
  return byUser;
}
